import {firebase} from "../auth";

export async function apiRequest(path, method = "GET", data) {
  const accessToken = firebase.auth().currentUser
    ? await firebase.auth().currentUser.getIdToken()
    : undefined;

    var headers = {
      "Content-Type": "application/json"
    }
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`
    }
                   
    // console.log(`${process.env.REACT_APP_APP_BASE_URL}/${path}`)
  return fetch(`${process.env.REACT_APP_APP_BASE_URL}/${path}`, {
    method: method,
    headers: headers,
    body: data ? JSON.stringify(data) : undefined,
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === "error") {
        // Automatically signout user if accessToken is no longer valid
        if (response.code === "auth/invalid-user-token") {
          firebase.auth().signOut();
        }

        throw new CustomError(response.code, response.message);
      } else {
        return response.data;
      }
    });
}

export async function oauthRequest(path, method = "GET", data) {
  const accessToken = firebase.auth().currentUser
    ? await firebase.auth().currentUser.getIdToken()
    : undefined;

    var headers = {
      "Content-Type": "application/json"
    }
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`
    }
  return fetch(`${process.env.REACT_APP_OAUTH_BASE_URL}/${path}`, {
    method: method,
    headers: headers,
    body: data ? JSON.stringify(data) : undefined,
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === "error") {
        // Automatically signout user if accessToken is no longer valid
        if (response.code === "auth/invalid-user-token") {
          firebase.auth().signOut();
        }

        throw new CustomError(response.code, response.message);
      } else {
        return response.data;
      }
    });
}

// Create an Error with custom message and code
export function CustomError(code, message) {
  const error = new Error(message);
  error.code = code;
  return error;
}
